'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BBBOZKTU.mjs";

// src/close/CloseIcon.tsx
import { jsx } from "react/jsx-runtime";
var CloseIcon = ({ className = "" }) => {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.16679 2.98828L10.0001 8.82162L15.8335 2.98828L17.012 4.16679L11.1786 10.0001L17.012 15.8335L15.8335 17.012L10.0001 11.1786L4.16679 17.012L2.98828 15.8335L8.82162 10.0001L2.98828 4.16679L4.16679 2.98828Z",
          fill: "currentColor"
        }
      )
    }
  );
};

// src/close/CircleCloseIcon.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var CircleCloseIcon = (props) => {
  return /* @__PURE__ */ jsx2(
    "svg",
    __spreadProps(__spreadValues({
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx2(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 1.5C5.30558 1.5 1.5 5.30558 1.5 10C1.5 14.6944 5.30558 18.5 10 18.5C14.6944 18.5 18.5 14.6944 18.5 10C18.5 5.30558 14.6944 1.5 10 1.5ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM6.46967 6.46967C6.76256 6.17678 7.23744 6.17678 7.53033 6.46967L10 8.93934L12.4697 6.46967C12.7626 6.17678 13.2374 6.17678 13.5303 6.46967C13.8232 6.76256 13.8232 7.23744 13.5303 7.53033L11.0607 10L13.5303 12.4697C13.8232 12.7626 13.8232 13.2374 13.5303 13.5303C13.2374 13.8232 12.7626 13.8232 12.4697 13.5303L10 11.0607L7.53033 13.5303C7.23744 13.8232 6.76256 13.8232 6.46967 13.5303C6.17678 13.2374 6.17678 12.7626 6.46967 12.4697L8.93934 10L6.46967 7.53033C6.17678 7.23744 6.17678 6.76256 6.46967 6.46967Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/close/SquareCloseIcon.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var SquareCloseIcon = (props) => {
  return /* @__PURE__ */ jsx3(
    "svg",
    __spreadProps(__spreadValues({
      width: "49",
      height: "51",
      viewBox: "0 0 49 51",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx3(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.1667 0.333328C14.2712 0.333328 15.1667 1.22876 15.1667 2.33333V5.66666H33.8333V2.33333C33.8333 1.22876 34.7288 0.333328 35.8333 0.333328C36.9379 0.333328 37.8333 1.22876 37.8333 2.33333V5.66666H46.5C47.6046 5.66666 48.5 6.56209 48.5 7.66666V49C48.5 50.1046 47.6046 51 46.5 51H2.5C1.39543 51 0.5 50.1046 0.5 49V7.66666C0.5 6.56209 1.39543 5.66666 2.5 5.66666H11.1667V2.33333C11.1667 1.22876 12.0621 0.333328 13.1667 0.333328ZM4.5 9.66666V47H44.5V9.66666H4.5ZM16.4138 20.2524C17.1949 19.4714 18.4612 19.4714 19.2423 20.2524L24.4996 25.5098L29.7569 20.2524C30.5379 19.4714 31.8043 19.4714 32.5853 20.2524C33.3664 21.0335 33.3664 22.2998 32.5853 23.0809L27.328 28.3382L32.58 33.5902C33.3611 34.3713 33.3611 35.6376 32.58 36.4187C31.799 37.1997 30.5327 37.1997 29.7516 36.4187L24.4996 31.1666L19.2475 36.4187C18.4665 37.1997 17.2002 37.1997 16.4191 36.4187C15.6381 35.6376 15.6381 34.3713 16.4191 33.5902L21.6712 28.3382L16.4138 23.0809C15.6328 22.2998 15.6328 21.0335 16.4138 20.2524Z",
          fill: "currentColor"
        }
      )
    })
  );
};

export {
  CloseIcon,
  CircleCloseIcon,
  SquareCloseIcon
};
//# sourceMappingURL=chunk-LSFKZ4NQ.mjs.map